import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ReceiptIcon from '@material-ui/icons/Receipt';
// Components

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import Preloader from "../../components/Preloader/Preloader";
import MUIDataTable from "mui-datatables";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";

import PDFPOReceive from "./PDFPOReceive";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		root: {
		  '&:nth-child(1)': {
			width: 120
		  },	
		  '&:nth-child(2)': {
			width: 180
		  },
		  '&:nth-child(3)': {
			width: 120
		  },
		  '&:nth-child(4)': {
			width: 150
		  },
		  '&:nth-child(5)': {
			width: 120
		  },
		  '&:nth-child(6)': {
			width: 180
		  }
		},
		toolButton: {
			justifyContent: 'center'
		}
	  }
	}
  });

const PurchaseReferenceView = () => {
	const { pono, branchidno} = useParams();
	const classes = useStyles();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [items, setItems] = useState([]); //data to display in PO table
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');
	const [dataLoaded, setDataLoaded] = useState(false);
	const [rcvItems, setRcvItems] = useState([]);
	const [rcvStatus, setRcvStatus] = useState(false);

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const DownloadPdf = ( {dateOfDel, delTo, mop, contact, address, pono, items, notes, shipping, subtotal, grandTotal, encoder, approver  } ) => {
		return (
		<PDFDownloadLink 
			document={
			<PDFPOReceive dateOfDel={dateOfDel} delTo={delTo} mop={mop} contact={contact} address={address} pono={items[0]?.pono} items={rcvItems} notes={notes} shipping={shipping} subtotal={subtotal} grandTotal={grandTotal} encoder={encoder} approver={approver} />} 
			fileName={"PO-Receive-"+items[0]?.pono+".pdf"}>
			{({ loading }) => (loading ? 'loading...' : <Button variant="contained" color="primary">Print PDF</Button> )}
		</PDFDownloadLink>
		)
	}

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'get_single_po_receive', {
			params:{
				rcvno: pono,
				jc_u_idno: branchidno,
			}
		}).then((res) => {
			setItems(res.data.data[0][1].po_details);
			setSupplierInfo(res.data.data[0][0].supplier_details);
			setShipTotal(res.data.data[0][0].supplier_details.shipping);
			setNotes(res.data.data[0][0].supplier_details.notes);
			setRcvItems(res.data.data[0][2].invrvc_details);
			if(res.data.data[0][0].supplier_details.rcv_status !== "No Delivery"){
				setRcvStatus(true);
			}
			setDataLoaded(true);
		}).catch((error)=>{
			// console.log(error);
			setDataLoaded(true);
		});

	};	
	const columns = [
		{
			name: "item_id",
			label: "Item Id",
			options: {
				//filter: false,
				// display: "excluded",
				setCellProps: value => ({ style: { textAlign: 'center' } }),
			},
		},
		{
			name: "item_name",
			label: "Item Name",
			options: {
				setCellProps: value => ({ style: { textAlign: 'center' } }),
			}
		},
		{
			name: "po_qty",
			label: "PO Qty",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"center"}}>{numeral(value).format('0,0')}</div>
					);
				  }
				}
		},
		{
			name: "uomDesc",
			label: "Unit",
			options: {
				setCellProps: value => ({ style: { textAlign: 'center' } }),
			}
		},
		{
			name: "qty_received",
			label: "Received Qty",
			options: {
				setCellProps: value => ({ style: { textAlign: 'center' } }),
			}
		},
		{
			name: "qty_received",
			label: "PO Rcv History",
			options: {
				setCellProps: value => ({ style: { textAlign: 'center' } }),
				customBodyRenderLite: (dataIndex) => {
					let qty_received =  items[dataIndex].qty_received;
					let item_id =  items[dataIndex].item_id;
					if(qty_received > 0){
							return (
								<NavLink to={"/purchases/purchases-order-receive-view/"+items[0]?.pono+"/"+branchidno+"/"+item_id}>
									<Button variant="contained" color="primary">
										View
									</Button>	
								</NavLink> 
									)
					}else{
						return(
							// <div>{qty_received}</div>
							""
						)
					}
				}
			}
		},
	];

	const options = {
		//hide toolbar functions
		toolbar:false,
		filter: false,
		viewColumns: false,
		search: false,
		download: false,
		print: false,
		csv: false,
		// filterType: "dropdown",
		selectableRows: "none",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		// tableBodyHeight,
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
                
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-receive"}><h2 style={{color:"black"}}>Purchase Order Receive</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order Receive #{items[0]?.pono}</h2>
                <Button onClick={() => history.goBack("-1")} color="success" variant="outlined" style={{marginLeft:"10px"}}>Back</Button>
             
			</div>
			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Purchase Order Receive View
								</div>
								<div className={classes.title}>
									{supplierInfo.purchase_from || "Purchased From"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
								{
									rcvStatus && //Check if Po has received any delivery
									<DownloadPdf 
									dateOfDel	= {supplierInfo.delivery_date || "Date of delivery"}
									delTo		= {supplierInfo.contactperson || "Purchased From"}
									mop			= {supplierInfo.modeofpayment || "Mode of Payment"}
									contact		= {supplierInfo.contactno || "Contact Number"}
									address		= {supplierInfo.address || "Address"}
									pono		= {pono}
									items		= {items}
									notes		= {notes || ''}
									shipping	= {numeral(shipTotal).format('0,0.00')}
									/>
								}
								
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Date of Delivery: 
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.delivery_date || "Date of delivery"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Purchase From
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.contactperson || "Purchased From"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.modeofpayment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Contact Number:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						{!dataLoaded ? (
								<Preloader />
							) : (
								<MuiThemeProvider theme={getMuiTheme()}>
									<MUIDataTable
										title={
											<div>
												<div className="table-subtitle">Table</div>
												<div className="table-title">
												Purchase Order Receive
												</div>
											</div>
										}
										data={items}
										columns={columns}
										options={options}
									/>
							  </MuiThemeProvider>
							// <div>render table here</div>
							)}
							{/* 	
								<div style={{textAlign:"right"}}className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(grandTotal).format('0,0.00')}
								</div>	
							</div>
						</div>*/}
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(shipTotal).format('0,0.00')}	
									</div>						
								</div>
							</div>
						</div>
						<TextField
							label="Notes"
							disabled={true}
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/> 
					</CardContent>
				</Card>

				{/* <div className={classes.buttonContainer}>
					<Button variant="contained">Back</Button> 
					<Button variant="contained" color="primary" onClick={approve_po}>
						Approve
					</Button>
				</div> */}
			</div>
		</div>
	);
};

export default PurchaseReferenceView;
